<template>
    <div class="container">
        <router-link :to="{name: 'ArticleList'}" class="title">
            Pratyaksh's Blog
        </router-link>
    </div>
</template>

<script>
    export default {
        name: "TopBar"
    }
</script>

<style scoped>
    .container {
        display: flex;
        justify-content: center;
        align-items: center;

        padding: 8px;
        color: white;
        font-size: 24px;
    }

    .title {
        cursor: pointer;
        text-decoration: none;
        color: white;
    }
</style>